(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.CampaignTargetSource = window.Dashboard.Models.CampaignTargetSource || {};

    class CampaignTargetSource {
        Id = undefined;
        Name = undefined;
        Description = undefined;
        TestStoreName = undefined;
        TestStoreId = undefined;
        Source = "";
        CampaignLevelId = Dashboard.Models.Lookups.CampaignLevelsWithoutAll.Brand;
        StatusId = Dashboard.Models.Lookups.CampaignTargetSourceStatuses.Test;
        LastModified = undefined;
        BrandId = undefined;
        AnalyticsCode = undefined;
        initialiseCampaignTargetSource = function (campaignTargetSource) {
            return Object.assign(this, campaignTargetSource);
        };
    }

    window.CampaignTargetSource = CampaignTargetSource;
    window.Dashboard.Models.CampaignTargetSource = CampaignTargetSource;
})();
